import React, { useState, useEffect } from 'react';
import './MarcasData.css';
import baseURL from '../../url';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import imageIcon from '../../../images/imageIcon.png';
import Swal from 'sweetalert2';

export default function MarcasData() {
    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editando, setEditando] = useState(null); // null = nueva, objeto = editar

    // Campos del formulario
    const [nombre, setNombre] = useState('');
    const [estado, setEstado] = useState('habilitado');
    const [logoPreview, setLogoPreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [bannerPreview, setBannerPreview] = useState(null);
    const [bannerFile, setBannerFile] = useState(null);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => { cargarMarcas(); }, []);

    const cargarMarcas = () => {
        setLoading(true);
        fetch(`${baseURL}/marcasGet.php`)
            .then(r => r.json())
            .then(d => setMarcas(d.marcas || []))
            .catch(() => setMarcas([]))
            .finally(() => setLoading(false));
    };

    const abrirNueva = () => {
        setEditando(null);
        setNombre('');
        setEstado('habilitado');
        setLogoPreview(null);
        setLogoFile(null);
        setBannerPreview(null);
        setBannerFile(null);
        setModalOpen(true);
    };

    const abrirEditar = (marca) => {
        setEditando(marca);
        setNombre(marca.nombre || '');
        setEstado(marca.estado || 'habilitado');
        setLogoPreview(marca.logo || null);
        setLogoFile(null);
        setBannerPreview(marca.banner || null);
        setBannerFile(null);
        setModalOpen(true);
    };

    const handleLogo = (e) => {
        const f = e.target.files[0];
        if (f) { setLogoFile(f); setLogoPreview(URL.createObjectURL(f)); }
    };

    const handleBanner = (e) => {
        const f = e.target.files[0];
        if (f) { setBannerFile(f); setBannerPreview(URL.createObjectURL(f)); }
    };

    const guardar = async () => {
        if (!nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
        setGuardando(true);
        const fd = new FormData();
        fd.append('nombre', nombre.trim());
        fd.append('estado', estado);
        if (logoFile) fd.append('logo', logoFile);
        if (bannerFile) fd.append('banner', bannerFile);
        if (editando) fd.append('idMarca', editando.idMarca);

        const url = editando ? `${baseURL}/marcaUpdate.php` : `${baseURL}/marcaPost.php`;
        try {
            const res = await fetch(url, { method: 'POST', body: fd });
            const data = await res.json();
            if (data.mensaje) {
                toast.success(editando ? 'Marca actualizada ✅' : 'Marca creada ✅');
                setModalOpen(false);
                cargarMarcas();
            } else {
                toast.error(data.error || 'Error al guardar');
            }
        } catch {
            toast.error('Error de conexión');
        }
        setGuardando(false);
    };

    const eliminar = (marca) => {
        Swal.fire({
            title: `¿Eliminar "${marca.nombre}"?`,
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#e53935',
        }).then(async (res) => {
            if (!res.isConfirmed) return;
            try {
                const fd = new FormData();
                fd.append('idMarca', marca.idMarca);
                const r = await fetch(`${baseURL}/marcaDelete.php`, { method: 'POST', body: fd });
                const d = await r.json();
                if (d.mensaje) { toast.success('Marca eliminada'); cargarMarcas(); }
                else toast.error(d.error || 'Error al eliminar');
            } catch { toast.error('Error de conexión'); }
        });
    };

    const toggleEstado = async (marca) => {
        const nuevoEstado = marca.estado === 'habilitado' ? 'deshabilitado' : 'habilitado';
        try {
            const fd = new FormData();
            fd.append('idMarca', marca.idMarca);
            fd.append('estado', nuevoEstado);
            const r = await fetch(`${baseURL}/marcaUpdate.php`, { method: 'POST', body: fd });
            const d = await r.json();
            if (d.mensaje) {
                cargarMarcas();
                toast.success(`Marca ${nuevoEstado}`);
            }
        } catch { toast.error('Error'); }
    };

    return (
        <div className="marcasData">
            <ToastContainer />
            <div className="marcasHeader">
                <h2>🏷️ Marcas</h2>
                <button className="btnNuevaMarca" onClick={abrirNueva}>+ Nueva marca</button>
            </div>

            {loading ? (
                <div className="marcasLoading">Cargando...</div>
            ) : marcas.length === 0 ? (
                <div className="marcasVacio">No hay marcas registradas. ¡Crea la primera!</div>
            ) : (
                <div className="marcasGrid">
                    {marcas.map(m => (
                        <div key={m.idMarca} className={`marcaCard ${m.estado === 'deshabilitado' ? 'deshabilitada' : ''}`}>
                            {m.banner && (
                                <div className="marcaBanner">
                                    <img src={m.banner} alt="banner" />
                                </div>
                            )}
                            <div className="marcaBody">
                                <div className="marcaLogo">
                                    {m.logo
                                        ? <img src={m.logo} alt={m.nombre} />
                                        : <span className="marcaLetra">{m.nombre?.[0]?.toUpperCase()}</span>
                                    }
                                </div>
                                <div className="marcaInfo">
                                    <h3>{m.nombre}</h3>
                                    <span className={`marcaEstadoBadge ${m.estado === 'habilitado' ? 'activa' : 'inactiva'}`}>
                                        {m.estado === 'habilitado' ? '✅ Activa' : '⛔ Inactiva'}
                                    </span>
                                </div>
                            </div>
                            <div className="marcaAcciones">
                                <button
                                    className={`btnToggle ${m.estado === 'habilitado' ? 'deshabilitar' : 'habilitar'}`}
                                    onClick={() => toggleEstado(m)}
                                    title={m.estado === 'habilitado' ? 'Deshabilitar' : 'Habilitar'}
                                >
                                    {m.estado === 'habilitado' ? '⛔ Deshabilitar' : '✅ Habilitar'}
                                </button>
                                <button className="btnEditarMarca" onClick={() => abrirEditar(m)}>✏️ Editar</button>
                                <button className="btnEliminarMarca" onClick={() => eliminar(m)}>🗑️ Eliminar</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal crear/editar */}
            {modalOpen && (
                <div className="marcaModalOverlay" onClick={() => setModalOpen(false)}>
                    <div className="marcaModal" onClick={e => e.stopPropagation()}>
                        <div className="marcaModalHeader">
                            <h3>{editando ? 'Editar marca' : 'Nueva marca'}</h3>
                            <button onClick={() => setModalOpen(false)}>✕</button>
                        </div>

                        <div className="marcaModalBody">
                            <label>Nombre *</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={e => setNombre(e.target.value)}
                                placeholder="Ej: Nike, Samsung..."
                            />

                            <label>Estado</label>
                            <div className="marcaEstadoToggle">
                                <button
                                    className={estado === 'habilitado' ? 'active' : ''}
                                    onClick={() => setEstado('habilitado')}
                                >✅ Habilitado</button>
                                <button
                                    className={estado === 'deshabilitado' ? 'active' : ''}
                                    onClick={() => setEstado('deshabilitado')}
                                >⛔ Deshabilitado</button>
                            </div>

                            <label>Logo de la marca</label>
                            <div className="marcaImgUpload">
                                <label htmlFor="logoInput" className="imgUploadLabel">
                                    {logoPreview
                                        ? <img src={logoPreview} alt="logo" className="imgPreview" />
                                        : <><img src={imageIcon} alt="" /><span>Subir logo</span></>
                                    }
                                </label>
                                <input id="logoInput" type="file" accept="image/*" onChange={handleLogo} style={{ display: 'none' }} />
                                {logoPreview && (
                                    <button className="btnQuitarImg" onClick={() => { setLogoPreview(null); setLogoFile(null); }}>
                                        🗑️ Quitar logo
                                    </button>
                                )}
                            </div>

                            <label>Banner (imagen ancha)</label>
                            <div className="marcaImgUpload">
                                <label htmlFor="bannerInput" className="imgUploadLabel bannerLabel">
                                    {bannerPreview
                                        ? <img src={bannerPreview} alt="banner" className="imgPreview bannerPreview" />
                                        : <><img src={imageIcon} alt="" /><span>Subir banner</span></>
                                    }
                                </label>
                                <input id="bannerInput" type="file" accept="image/*" onChange={handleBanner} style={{ display: 'none' }} />
                                {bannerPreview && (
                                    <button className="btnQuitarImg" onClick={() => { setBannerPreview(null); setBannerFile(null); }}>
                                        🗑️ Quitar banner
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="marcaModalFooter">
                            <button className="btnCancelar" onClick={() => setModalOpen(false)}>Cancelar</button>
                            <button className="btnGuardar" onClick={guardar} disabled={guardando}>
                                {guardando ? 'Guardando...' : editando ? 'Actualizar' : 'Crear marca'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
